module.exports = __webpack_public_path__ + "static/media/IMG_4278.5b9e3807.PNG";